<template>

  <div class="card card-modal">
    <div class="row card-header">
      <div class="col-12">
        {{pageTitle}}
      </div>
    </div>

    <div class="row card-body">
      <div class="col-12">
        <p class="card-text">Mensagem</p>
        <textarea class="form-control" cols="30" v-model="form.mensagem" rows="5"></textarea>
      </div>

      <div class="col-12 ">
        <my-alert
          class="alert-danger text-center mt-3"
          @done='showError = false'
          :message ='errorMessage'
          :show='showError'
          :timeout="10000"
        ></my-alert>
      </div>
    </div>

    <div class="row card-footer">
      <div class="col">
        <button class="btn col-6 btn-danger btn-md" @click="$emit('close')">
          <font-awesome-icon icon="times" class="pointer" />
        </button>
        <button class="btn col-6 btn-success btn-md" @click="confirm()">
          <font-awesome-icon icon="check" class="pointer" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['mensagem'],
  data() {
    return {
      pageTitle: 'Nova mensagem',
      form:{
        mensagem:''
      }
    }
  },
  mounted() {
    if (this.mensagem._id) {
      this.pageTitle ="Edição de mensagem";
      this.form = JSON.parse(JSON.stringify(this.mensagem));
    }
  },
  methods: {
    async confirm(){
      if (this.form.mensagem) {
        let response = {};
        if(this.form._id) {
          response = await this.$http.put('/v1/v3/mensagens-pre', this.form );
        } else {
          response = await this.$http.post('/v1/v3/mensagens-pre', { mensagem: this.form.mensagem });
        }


        if (!response.success) {
          this.errorMessage = response.err;
          this.showError = true;
        } else{
          if (this.mensagem._id) {
            this.$toasted.show('Editada com sucesso', { icon: 'check', type: 'success' });
          } else {
            this.$toasted.show('Cadastrada com sucesso', { icon: 'check', type: 'success' });
          }
          this.$emit('close');
        }
      }
    }
  }
};
</script>
